export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5417.5691c623.jpg";